import React, { useState, useEffect } from 'react';
import client from './contentfulClientToken';
import { Navigate, useLocation, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles.scss';
import ArchiveList from './components/ArchiveList';
import HandwrittingBackground from './components/HandwrittingBackground';
import TestScrollInfiniteData from './components/TestScrollInfiniteData';
import { AnimatePresence } from 'framer-motion';
// Tag and year components for AnimatedRoutes
import People from './components/tags/People';
import Japan from './components/tags/Japan';
import Nature from './components/tags/Nature';
import Europe from './components/tags/Europe';
import City from './components/tags/City';
import Iceland from './components/tags/Iceland';
import Hospital from './components/tags/Hospital';
import Water from './components/tags/Water';
import Thoughts from './components/tags/Thoughts';
import ChateauTimo from './components/tags/ChateauTimo';
import { YEARS } from './components/tags/yearConfig';
import YearTagRoute from './components/tags/YearTagRoute';
import Info from './components/Info';

const App = () => {
    const [months, setMonths] = useState([]);
    const [loading, setLoading] = useState(true);
    const [yearsIsVisible, setYearsIsVisible] = useState(false);
    const [monthsIsVisible, setMonthsIsVisible] = useState(false);
    const [keywordsIsVisible, setKeywordsIsVisible] = useState(false);

    useEffect(() => {
        client.getEntries({ content_type: 'month' })
            .then(response => {
                // Sort months by number field in descending order
                const sortedMonths = response.items.sort((a, b) => b.fields.number - a.fields.number);
                setMonths(sortedMonths);
                setLoading(false);

                // console.log(sortedMonths);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            });
    }, []);

    const [entranceHandwritingUrl, setEntranceHandwritingUrl] = useState(null);

    useEffect(() => {
        client.getEntry('3htcsE5q2KsuXqfmaaxGSe')
            .then(entry => {
                // Access the image URL from the nested structure
                const entranceHandwritting = entry.fields.entranceHandwritting;
                if (entranceHandwritting && entranceHandwritting.fields && entranceHandwritting.fields.file && entranceHandwritting.fields.file.url) {
                    let imageUrl = entranceHandwritting.fields.file.url;
                    // Prepend 'https:' if not already present
                    if (!imageUrl.startsWith('http')) {
                        imageUrl = 'https:' + imageUrl;
                    }
                    setEntranceHandwritingUrl(imageUrl);
                    //console.log('Entrance Handwriting Image URL:', imageUrl);
                } else {
                    setEntranceHandwritingUrl(null);
                    //console.log('No entrance handwriting image found.');
                }
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            });
    }, []);

    /*   if (loading) return <div className="loader">loading</div>; */

    //if (loading) return <img src={entranceHandwritingUrl} alt="handwriting background" />

    // Get the last month from the array (now it will be the first one due to sorting)
    const lastMonth = months[0];

    return (
        <Router>
            <>
                <AnimatedRoutes
                    months={months}
                    lastMonth={lastMonth}
                    yearsIsVisible={yearsIsVisible}
                    monthsIsVisible={monthsIsVisible}
                    keywordsIsVisible={keywordsIsVisible}
                    setYearsIsVisible={setYearsIsVisible}
                    setMonthsIsVisible={setMonthsIsVisible}
                    setKeywordsIsVisible={setKeywordsIsVisible}
                />
                <ArchiveList
                    yearsIsVisible={yearsIsVisible}
                    setYearsIsVisible={setYearsIsVisible}
                    monthsIsVisible={monthsIsVisible}
                    setMonthsIsVisible={setMonthsIsVisible}
                    keywordsIsVisible={keywordsIsVisible}
                    setKeywordsIsVisible={setKeywordsIsVisible}
                />
                <HandwrittingBackground imageUrl={entranceHandwritingUrl} />
                <Info imageUrl={entranceHandwritingUrl} />
            </>
        </Router>
    );
};

// AnimatedRoutes component for route transitions
function AnimatedRoutes({
    months,
    lastMonth,
    yearsIsVisible,
    monthsIsVisible,
    keywordsIsVisible,
    setYearsIsVisible,
    setMonthsIsVisible,
    setKeywordsIsVisible
}) {
    const location = useLocation();
    return (
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route path="/people" element={<People yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/japan" element={<Japan yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/nature" element={<Nature yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/europe" element={<Europe yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/city" element={<City yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/iceland" element={<Iceland yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/hospital" element={<Hospital yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/water" element={<Water yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/thoughts" element={<Thoughts yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                <Route path="/chateautimo" element={<ChateauTimo yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                {/* Auto-generate explicit year redirects and a single dynamic year route */}
                {YEARS.map((y) => (
                    <Route key={`year-${y}`} path={`/${y}`} element={<YearTagRoute forcedYear={y} yearsIsVisible={yearsIsVisible} monthsIsVisible={monthsIsVisible} keywordsIsVisible={keywordsIsVisible} />} />
                ))}
                {/* <Route path="/gridfilter" element={<GridFilter />} /> */}

                <Route path="/" element={lastMonth ? <Navigate to={`/${lastMonth.fields.url}`} replace /> : <div>No months available</div>} />
                {months.map((month) => (
                    <Route
                        key={month.sys.id}
                        path={`/${month.fields.url}`}
                        element={
                            <TestScrollInfiniteData
                                data={month}
                                months={months}
                                yearsIsVisible={yearsIsVisible}
                                monthsIsVisible={monthsIsVisible}
                                keywordsIsVisible={keywordsIsVisible}
                                setYearsIsVisible={setYearsIsVisible}
                                setMonthsIsVisible={setMonthsIsVisible}
                                setKeywordsIsVisible={setKeywordsIsVisible}
                            />
                        }
                    />
                ))}
                {/* Catch-all route to redirect any invalid URLs to home - must be the very last route */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AnimatePresence>
    );
}

export default App;
